import * as tslib_1 from "tslib";
import { ODataGridComponent, } from '@pages/generics/grid';
import { ModalService, } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { MLPackageUploadModalComponent, MLPackageVersionsModalComponent, } from './modals';
var MLPackagesPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MLPackagesPageComponent, _super);
    function MLPackagesPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._modalService = _this._injector.get(ModalService);
        return _this;
    }
    MLPackagesPageComponent.prototype.uploadModelVersion = function (model) {
        var _this = this;
        var clone = cloneDeep(model);
        this._modalService
            .openModal(MLPackageUploadModalComponent, clone)
            .afterClosedResult()
            .subscribe(function (_) { return _this._refresh$.next(); });
    };
    MLPackagesPageComponent.prototype.showMLPackageVersions = function (model) {
        var _this = this;
        var clone = cloneDeep(model);
        this._modalService
            .openModal(MLPackageVersionsModalComponent, clone)
            .afterClosedResult()
            .subscribe(function (_) { return _this._refresh$.next(); });
    };
    return MLPackagesPageComponent;
}(ODataGridComponent));
export { MLPackagesPageComponent };
